import axios from "@/plugins/axios";

let appOrigin = process.env.VUE_APP_ORIGIN;
const setAppOrigin = (origin) => {
  appOrigin = origin;
};

const setAxiosBaseUrl = (baseUrl) => {
  axios.defaults.baseURL = baseUrl;
};

function getDataString(data = {}) {
  let dataString = "";

  for (const key in data) {
    dataString +=
      "&" + key + "=" + encodeURIComponent(String(data[key])).trim();

    if (
      data[key] &&
      typeof data[key] === "object" &&
      data[key].constructor === Array
    ) {
      for (const arraykey in data[key]) {
        dataString += "&" + key + "[]=" + data[key][arraykey];
      }
    }
  }
  dataString = dataString.substr(1);
  return dataString;
}

const ztkLocations = [
  {
    id: 48874,
    name: "Augsburg",
    position: { lat: 48.3698336, lng: 10.8935365 },
    tel: "+49(0)821-50867890",
    address: {
      street: "Ludwigstraße",
      housenumber: "1",
      zip: "86150",
      city: "Augsburg",
    },
    bookUrl:
      "https://www.doctolib.de/zmvz-zahnmedizinisches-versorgungszentrum/augsburg/ztk-augsburg/booking?bookingFunnelSource=external_referral&profile_skipped=true",
  },
  {
    id: 48875,
    name: "Böblingen",
    position: { lat: 48.6889771, lng: 9.001867 },
    tel: "+49(0)7031-205020",
    address: {
      street: "Konrad-Zuse-Str.",
      housenumber: "12",
      zip: "71034",
      city: "Böblingen",
    },
  },
  {
    id: 48876,
    name: "Landshut",
    position: { lat: 48.5395184, lng: 12.1542581 },
    tel: "+49(0)871-9749136-0",
    address: {
      street: "Am Alten Viehmarkt",
      housenumber: "5",
      zip: "84028",
      city: "Landshut",
    },
  },
  {
    id: 48877,
    name: "Mainaschaff",
    position: { lat: 49.9881507, lng: 9.0799036 },
    tel: "+49(0)6021-581360",
    address: {
      street: "Am Glockenturm",
      housenumber: "1",
      zip: "63814",
      city: "Mainaschaff",
    },
  },
  {
    id: 48878,
    name: "Mainz",
    position: { lat: 50.0116495, lng: 8.259341 },
    tel: "+49(0)6131-27544-0",
    address: {
      street: "Rheinallee",
      housenumber: "53",
      zip: "55118",
      city: "Mainz",
    },
  },
  {
    id: 48879,
    name: "München - Schwabing",
    position: { lat: 48.1780692, lng: 11.5837362 },
    tel: "+49(0)89-3589588-0",
    address: {
      street: "Leopoldstr.",
      housenumber: "230",
      zip: "80807",
      city: "München",
    },
    bookUrl:
      "https://www.doctolib.de/zmvz-zahnmedizinisches-versorgungszentrum/muenchen/ztk-zahngesundheit-muenchen-schwabing-leopoldstrasse/booking/specialities?profile_skipped=true&utm_source=-website-button&utm_medium=referral&utm_campaign=website-button&utm_content=custom&bookingFunnelSource=external_referral",
  },
  {
    id: 48880,
    name: "München - Sendling",
    position: { lat: 48.1005053, lng: 11.5245454 },
    tel: "+49(0)89-2020990-0",
    address: {
      street: "Boschetsriederstr.",
      housenumber: "72",
      zip: "81379",
      city: "München",
    },
    bookUrl:
      "https://www.doctolib.de/zmvz-zahnmedizinisches-versorgungszentrum/muenchen/ztk-muenchen-sendling/booking/specialities?profile_skipped=true&bookingFunnelSource=external_referral",
  },
  {
    id: 48881,
    name: "Nürnberg",
    position: { lat: 49.4509091, lng: 11.0721944 },
    tel: "+49(0)911-255227-0",
    address: {
      street: "Karolinenstraße",
      housenumber: "43-45",
      zip: "90402",
      city: "Nürnberg",
    },
    bookUrl:
      "https://www.doctolib.de/zmvz-zahnmedizinisches-versorgungszentrum/nuernberg/ztk-ztk-nuernberg/booking/specialities?profile_skipped=true&utm_source=-website-button&utm_medium=referral&utm_campaign=website-button&utm_content=custom&bookingFunnelSource=external_referral",
  },
  {
    id: 48882,
    name: "Regensburg",
    position: { lat: 49.0098871, lng: 12.0876692 },
    tel: "+49(0)941-280758-0",
    address: {
      street: "Bischof-von-Henle-Str.",
      housenumber: "2a",
      zip: "93051",
      city: "Regensburg",
    },
  },
  {
    id: 48883,
    name: "Riedenburg",
    position: { lat: 48.963082, lng: 11.6864762 },
    tel: "+49(0)9442-921080",
    address: {
      street: "Kelheimer Str.",
      housenumber: "5",
      zip: "93339",
      city: "Riedenburg",
    },
  },
  {
    id: 48884,
    name: "Reutlingen",
    position: { lat: 48.4941472, lng: 9.2069925 },
    tel: "+49(0)7121-994394-0",
    address: {
      street: "Eberhardstr.",
      housenumber: "1",
      zip: "72764",
      city: "Reutlingen",
    },
  },
  {
    id: 48885,
    name: "Schmidmühlen",
    position: { lat: 49.267633, lng: 11.9188534 },
    tel: "+49(0)9474-9406-0",
    address: {
      street: "Poststraße",
      housenumber: "3",
      zip: "92287",
      city: "Schmidmühlen",
    },
  },
  {
    id: 48886,
    name: "Ulm",
    position: { lat: 48.3985007, lng: 9.9870249 },
    tel: "+49(0)731-3980890",
    address: {
      street: "Hirschstraße",
      housenumber: "1",
      zip: "89073",
      city: "Ulm",
    },
  },
  {
    id: 48887,
    name: "Würzburg",
    position: { lat: 49.7945656, lng: 9.9343168 },
    tel: "+49(0)931-4652860",
    address: {
      street: "Theaterstraße",
      housenumber: "23",
      zip: "97070",
      city: "Würzburg",
    },
  },
];

const generalPrivacyPolicy = `
<p>Diese Datenschutzerklärung (iSd Art 13 und 14 DSGVO) beschreibt, wie ROODIE HEALTH GMBH (im Folgenden "Wir") personenbezogenen Daten von betroffenen Personen (im Folgenden "Nutzer") verarbeitet.</p>

<p><strong>1. Verantwortliche und Kontaktdaten</strong></p>

<p>Verantwortliche im Sinne der Datenschutz-Grundverordnung (DSGVO): ROODIE HEALTH GMBH</p>

<p>Anschrift: Urstein Süd 15, 5412 Puch bei Hallein</p>

<p>E-Mail-Adresse: <a href="mailto:security@roodie-health.com">security@roodie-health.com</a></p>

<p>Webseite: www.roodie-health.com (im Folgenden "Plattform")</p>

<p><strong>2. Zweck der Verarbeitung</strong></p>

<p>Personenbezogene Daten über den Nutzer werden erhoben, damit wir die angebotenen Dienste erbringen und des Weiteren unseren gesetzlichen Pflichten nachkommen, auf geltend gemachte Ansprüche und Forderungen reagieren oder unsere Rechte und Interessen (oder die der Nutzer oder Dritter) schützen können. Im Zuge dessen können Daten zu folgenden Zwecken erhoben werden: Anmeldung und eindeutigen Authentifizierung, Verwaltung von Support- und Kontaktanfragen und der Bereitstellung Ihres Nutzer-Accounts. Um das Nutzen der Roodie Dienstleistungen zu ermöglichen sowie die Gesundheitsdaten und –dokumente mit Ärzten auszutauschen, ist das Erstellen eines Nutzerkontos notwendig. Das Erstellen des Nutzerkontos ist Voraussetzung für die Nutzung der Roodie Dienstleistungen und für den Austausch von Gesundheitsdaten und -dokumenten mit Leistungserbringern.</p>

<p><strong>3. Kategorien der verarbeiteten personenbezogenen Daten</strong></p>

<p>Personenbezogene Daten sind Informationen, die sich auf eine identifizierte oder identifizierbare natürliche Person (sogenannte "betroffene Person") beziehen. Beispiele dafür sind Name, Anschrift, E-Mail-Adresse. Je nach konkretem Benutzen der App oder Website werden verschiedene Kategorien personenbezogener Daten verarbeitet. Dies beinhaltet unter anderem Ihre Gesundheitsdaten, die Sie in der Roodie App/Website angeben. Dazu gehören unter anderem Ihre Angaben über Ihre gesundheitlichen Beschwerden, medizinische Anliegen, Medikationen und Behandlungen, Vorerkrankungen, Ärzte, Termine. Dabei handelt es sich um sensible Gesundheitsdaten, die in verschlüsselter Form in/auf der Roodie App/Website gespeichert werden.</p>

<ul>
	<li><strong>Installieren und Benützen der App bzw Website</strong></li>
</ul>

<p></p>

<ul>
	<li>Wir verarbeiten hierbei jene personenbezogenen Daten, die bei der bloß informatorischen Nutzung der Plattform anfallen, ohne gesonderte Einwilligung ausschließlich zur Durchführung des Nutzungsverhältnisses.</li>
</ul>

<ul>
	<li>Beim Aufrufen der Website bzw Installation der App ohne Erstellen eines Benutzerprofils erheben wir folgende Daten, die vom Browser des Nutzers übermittelt werden und technisch erforderlich sind, um den Nutzern die Plattform anzuzeigen und die Stabilität sowie Sicherheit zu gewährleisten:</li>
	<li>IP-Adresse des Nutzers</li>
	<li>Name der aufgerufenen Webseite bzw Datei</li>
	<li>Datum und Uhrzeit des Zugriffs</li>
	<li>Übertragende Datenmenge</li>
	<li>Meldung über erfolgreichen Abruf</li>
	<li>Browsertyp und –version</li>
	<li>Betriebssystem und dessen Oberfläche</li>
	<li>Sprache und Version der Browsersoftware</li>
</ul>

<p>Diese Daten werden nicht mit anderen personenbezogenen Daten, die der Nutzer aktiv im Rahmen der Plattform angibt, zusammengeführt.</p>

<ul>
	<li>Wenn ein Benutzerprofil erstellt wird, wird der Nutzer aufgefordert, personenbezogene Daten einzugeben:</li>
	<li>Versicherungsnummer</li>
	<li>Geburtsdatum</li>
	<li>Name</li>
	<li>E-Mail-Adresse</li>
	<li>Mobilnummer</li>
	<li>Geschlecht</li>
	<li>Adresse</li>
</ul>

<p>Beim Erstellen des Benutzerprofils kann Folgendes optional angegeben werden:</p>

<ul>
	<li>Gewicht</li>
	<li>Körpergröße</li>
	<li>Bestehende Diagnosen bzw Krankheiten</li>
	<li>Vorerkrankungen</li>
	<li>Allergien bzw Unverträglichkeiten</li>
	<li>Impfungen</li>
	<li>Blutgruppe</li>
	<li>Notfalldaten</li>
	<li>Ärzte</li>
	<li>Termine</li>
	<li>Befunde</li>
	<li>Raucher</li>
	<li>Hauttyp</li>
	<li>Sehstärke</li>
	<li>Zahnersatz</li>
	<li>Organspender</li>
</ul>

<p></p>

<ul>
	<li><strong>Kontaktdaten</strong></li>
</ul>

<p>Wenn eine betroffene Person per Formular auf der Website oder per E-Mail Kontakt mit uns aufnimmt, werden die Daten, die diese Person angibt, zwecks Bearbeitung der Anfrage und für den Fall von Rückfragen sechs Monate bei uns gespeichert. Diese Daten werden nicht ohne Einwilligung des Nutzers weitergereicht.</p>

<p><strong>4. Automatisierte Entscheidungsfindung gem Art 22 DSGVO</strong></p>

<p>Wir nutzen keine automatisierten Entscheidungsfindungen nach Art 22 DSGVO.</p>

<p><strong>5. Rechtsgrundlagen der Verarbeitung</strong></p>

<p>Wir erheben, verarbeiten und nutzen Ihre personenbezogenen Daten ausschließlich dann, wenn eine Rechtsgrundlage iSd Art 6 DSGVO gegeben ist, insbesondere:</p>

<ul>
	<li><strong>Berechtigtes Interesse – Art 6 Abs 1 lit f DSGVO</strong></li>
</ul>

<p>Wenn die Verarbeitung von personenbezogenen Daten zur Wahrung eines berechtigten Interesses unseres Unternehmens oder eines Dritten erforderlich ist, dient Art&nbsp;6&nbsp;Abs&nbsp;1&nbsp;lit&nbsp;f&nbsp;DSGVO als Rechtsgrundlage. Unser berechtigtes Interesse besteht insbesondere darin,</p>

<ul>
	<li>den Betrieb und die Verwaltung der Webseite bzw. App sicherzustellen und diese zu verbessern;</li>
</ul>

<ul>
	<li>die Netzwerk- und Datensicherheit zu gewährleisten, dies jedoch nur insofern, als unser berechtigtes Interesse mit dem geltenden Recht und mit den Rechten und Freiheiten unserer Nutzer im Einklang ist;</li>
</ul>

<ul>
	<li>zum Geltendmachen, Ausüben oder Verteidigen von Rechtsansprüchen;</li>
</ul>

<ul>
	<li>die Kontaktaufnahmen des Nutzers per E-Mail oder Plattform zu verarbeiten.</li>
</ul>

<ul>
	<li><strong>Zur Erfüllung eines Vertrags – Art 6 Abs 1 lit b DSGVO</strong></li>
</ul>

<p>Die Rechtsgrundlage für die Datenverarbeitung aufgrund eines Vertrags beruht auf der Rechtsgrundlage des Art 6 Abs 1 lit b DSGVO. Darunter fallen auch Daten, die wir aufgrund von vorvertraglichen Pflichten verarbeiten. Die Daten, die die Nutzer uns im Zusammenhang mit dem Erstellen eines Benutzerkontos mitteilen, werden von uns auf dieser Rechtsgrundlage erhoben, gespeichert und verarbeitet. Dies gilt für den Zeitraum der Nutzung unserer Servicedienste, einschließlich eventueller Gewährleistungen.</p>

<ul>
	<li><strong>Einwilligung – Art&nbsp;6&nbsp;Abs&nbsp;1&nbsp;lit&nbsp;a&nbsp;DSGVO</strong></li>
</ul>

<p>Die Nutzer haben ihre Einwilligung für einen oder mehrere bestimmte Zwecke erteilt. Der Umfang und die Zwecke der Verarbeitungen richten sich nach der zugrunde liegenden Einwilligungserklärung. Der Nutzer kann eine erteilte Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen, indem er mittels E-Mail an uns die Einwilligung widerruft.</p>

<ul>
	<li>Sofern Sie zustimmen, verarbeiten wir Ihre angegebenen Gesundheitsdaten, um unseren Service anzubieten. Es werden nur die Gesundheitsdaten verarbeitet, die Sie im Zuge der vom Roodie.Bot gestellten Fragen angeben, um Ihre Symptome zu erheben. Wir routen Sie daraufhin zu einem Gesundheitsservicepartner, der entweder einen passenden Arzt für Ihre Beschwerden sucht, ein Coaching, direkt die Behandlung bzw. ein etwaiges Gesundheitsservice erbringt. Zudem wird der Roodie.Bot mithilfe von anonymisierten Daten trainiert.</li>
</ul>

<ul>
	<li><strong>Rechtliche Pflichten – Art 6 Abs 1 lit c DSGVO</strong></li>
</ul>

<p>Unterliegen wir einer rechtlichen Pflicht, aufgrund derer ein Verarbeiten von personenbezogenen Daten erforderlich ist, so dient Art&nbsp;6&nbsp;Abs&nbsp;1&nbsp;lit&nbsp;c&nbsp;DSGVO als Rechtsgrundlage.</p>

<p><strong>6. Übermittlung an Dritte</strong></p>

<p>6.1. Aufgrund der heutigen Komplexität bestimmter Datenverarbeitungsprozesse ist es für uns unerlässlich geworden, gewisse Dienstleistungen unter Mitwirkung von Dritten zu erbringen. Dafür bedienen wir uns externer Dienstleister, zB für unsere IT-Systeme, denen Ihre Daten hierfür bereitgestellt werden. Bei diesen Dienstleistern handelt es sich um Auftragsverarbeiter im Sinn des Art 28 DSGVO, die wir vertraglich dazu verpflichtet haben, Ihre Daten vertraulich zu behandeln und Ihre Daten nur im Rahmen ihrer Leistungserbringung zu verarbeiten.</p>

<p>6.2. Außerdem werden die personenbezogenen Daten zur Kontaktaufnahme sowie Diagnose an Ihren behandelnden Arzt übermittelt, den Sie mithilfe der Roodie-App ausgewählt haben.</p>

<p>6.3. Der mögliche Empfänger Ihrer personenbezogenen Daten befindet sich ausschließlich in der EU, Deutschland und Österreich, und wird auch nur in diesem Land verarbeitet und gespeichert.</p>

<p>6.4. Unter gewissen Umständen können wir gesetzlich verpflichtet sein, Ihre Daten an zB Aufsichtsbehörden und Strafverfolgungsbehörden weiterzugeben. Dies jedoch nur, soweit es zur Verhinderung und/oder Aufdeckung von Betrugsfällen und sonstigen Straftaten bzw zur Gewährleistung der Netzwerk- und Datensicherheit erforderlich ist.</p>

<p><strong>7. Aufbewahrung der Daten</strong></p>

<p>7.1. Die Daten werden verarbeitet, solange dies zur Erfüllung unserer vertraglichen bzw. gesetzlichen Aufbewahrungspflichten, zur Abwehr allfälliger Haftungsansprüche und für die Dauer der Einwilligungserklärung erforderlich ist. Wir tragen dafür Sorge, dass Ihre personenbezogenen Daten über den gesamten Zeitraum gemäß dieser Datenschutzerklärung behandelt werden. Personenbezogene Daten werden daher so lange verarbeitet und gespeichert, wie es der Zweck erfordert, zu dem sie erhoben wurden. Nach Ablauf der Aufbewahrungsfrist werden personenbezogene Daten gelöscht.</p>

<p>7.2. Wir verarbeiten die Nutzerdaten auf ordnungsgemäße Weise und ergreifen angemessene Sicherheitsmaßnahmen, um den unbefugten Zugriff und die unbefugte Weiterleitung, Veränderung oder Vernichtung von Daten zu vermeiden. Die Datenverarbeitung wird mittels Computern oder IT-basierten Systemen nach organisatorischen Verfahren und Verfahrensweisen durchgeführt, die gezielt auf die angegebenen Zwecke abstellen.</p>

<p><strong>8. Daten, die nicht direkt bei der betroffenen Person erhoben werden</strong></p>

<p>Daten, die nicht direkt von uns bei der betroffenen Person, also dem Nutzer, erhoben werden, sind bspw. Daten, welche öffentlich zugänglich sind oder über einen Dritten mitgeteilt werden.</p>

<p><strong>9. Rechte der Nutzer als betroffene Personen</strong></p>

<ul>
	<li>Als betroffene Person haben Sie Rechte im Sinne der DSGVO:
	<ul>
		<li>Auskunftsrecht: Sie haben das Recht, von uns eine Bestätigung dahingehend einzuholen, ob wir aktuell Ihre personenbezogenen Daten verarbeiten. Sollten wir Ihre personenbezogenen Daten verarbeiten, haben Sie das Recht, auf Ihre personenbezogenen Daten zuzugreifen und nähere Informationen hinsichtlich der Verarbeitung Ihrer personenbezogenen Daten einzuholen (Artikel 15 der DSGVO).</li>
		<li>Recht auf Richtigstellung: Falls Ihre personenbezogenen Daten unzutreffend sind, haben Sie das Recht, Ihre personenbezogenen Daten korrigieren zu lassen. Sie können Ihre personenbezogenen Daten auch richtigstellen, indem Sie die personenbezogenen Daten in Ihren Kontoeinstellungen überprüfen und abändern (Artikel 16 der DSGVO).</li>
		<li>Recht auf Löschung: Unter bestimmten Bedingungen haben Sie das Recht, die Löschung Ihrer personenbezogenen Daten anzufordern (Artikel 17 der DSGVO).</li>
		<li>Recht auf Einschränkung der Verarbeitung: Unter bestimmten Bedingungen haben Sie das Recht, die Verarbeitung Ihrer personenbezogenen Daten einzuschränken (Artikel 18 der DSGVO).</li>
		<li>Recht auf Einspruch gegen die Verarbeitung: Unter bestimmten Bedingungen haben Sie das Recht, der Verarbeitung Ihrer personenbezogenen Daten zu widersprechen (Artikel 21 der DSGVO).</li>
	</ul>
	</li>
	<li>Ihre Eingabe auf Auskunft, Löschen, Berichtigen, Widerspruch und/oder Datenübertragen kann an unsere E-Mail-Adresse hallo@roodie-health.com gerichtet werden. Alle Anfragen zur Ausübung der Nutzerrechte sind kostenlos und werden vom Anbieter so früh wie möglich, spätestens innerhalb eines Monats, bearbeitet.</li>
	<li>Wenn Sie der Auffassung sind, dass die Verarbeitung Ihrer personenbezogenen Daten durch uns gegen das geltende Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche in einer anderen Weise verletzt worden sind, besteht die Möglichkeit, sich bei der zuständigen Aufsichtsbehörde zu beschweren. In Österreich zuständig ist hierfür die Datenschutzbehörde (<a href="http://www.dsb.gv.at">dsb.gv.at</a>).</li>
</ul>

<p><strong>10. Änderung der Datenschutzerklärung</strong></p>

<p>Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf, etwa aufgrund von technischen Entwicklungen oder rechtlicher Änderungen, anzupassen oder im Zusammenhang mit dem Angebot neuer Dienstleistungen oder Produkte zu aktualisieren. Die aktualisierte Datenschutzerklärung wird jeweils auf unserer Website veröffentlicht. Bitte prüfen Sie regelmäßig die betreffende Seite.</p>

<p><strong>Aktueller Stand der Datenschutzerklärung</strong>: 08.2021</p>
`;

const generalUsagePolicy = `
<p>Diese Nutzungsbedingungen regeln das Vertragsverhältnis für die Nutzung der Dienste, die unter der Website roodie-health.com und in der App ROODIE ("<strong>APP</strong>") von uns, der ROODIE HEALTH GMBH, Urstein Süd 15, 5412 Puch bei Hallein, Österreich, eingetragen im Firmenbuch des Handelsgerichts Wien unter FN&nbsp;516782&nbsp;z ("<strong>wir</strong>", "<strong>uns</strong>" oder "<strong>ROODIE</strong>") dir, dem Nutzer, angeboten werden.</p>

<ol>
	<li>GEGENSTAND DES VERTRAGS</li>
</ol>

<ul>
	<li>ROODIE schlägt dir auf der unter roodie-health.com und über die APP abrufbare Online-Plattform (die "PLATTFORM") auf Basis eines von dir auszufüllenden Fragebogens medizinische Partnerunternehmen der ARAG Krankenversicherungs-AG vor, die wiederum dich an die bei solchen Partnerunternehmen angestellten Ärzte verweisen. Dabei füllst du eine Reihe von Fragen aus, mit denen, unter anderem, Name, Kontaktdaten, Symptome und bevorzugte Beratungsweise eruiert werden. Anschließend wirst du auf die Website der medizinischen Partnerunternehmen weitergeleitet.<br />
	&nbsp;</li>
	<li>Wir stellen keine Diagnosen oder Prognosen, sondern vermittelt ausschließlich an jene medizinischen Partnerunternehmen weiter, welche am geeignetsten zu deinen Angaben passen.</li>
</ul>

<ol start="2">
	<li>NUTZUNG DER PLATTFORM</li>
</ol>

<ul>
	<li>Für die Nutzung der PLATTFORM gibst du in einem ersten Schritt dein Geburtsdatum und deine Versicherungsnummer der ARAG Krankenversicherungs-AG an. Ohne eine solche ARAG-Versicherungsnummer ist eine Nutzung der PLATTFORM derzeit nicht möglich.<br />
	&nbsp;</li>
	<li>Indem du anschließend deine E-Mail-Adresse eingibst, akzeptierst du durch Anklicken einer entsprechenden Checkbox diese Nutzungsbedingungen für die Nutzung der PLATTFORM und es kommt zwischen ROODIE und dir ein Nutzungsverhältnis zustande.</li>
</ul>

<ul>
	<li>Eine Nutzung der PLATTFORM ist nur bei Akzeptanz dieser Nutzungsbedingungen möglich. ROODIE behält sich das Recht vor, den Zugang für Nutzer zu untersagen, die diese Nutzungsbedingungen nicht einhalten.</li>
</ul>

<ul>
	<li>ROODIE räumt dir das nicht-exklusive, beschränkbare, nicht übertragbare und nicht unterlizenzierbare, zeitlich auf die Laufzeit des Nutzungsverhältnisses begrenzte Recht ein, die PLATTFORM in der jeweils aktuellen Fassung samt Updates und anderen Bestandteilen in Übereinstimmung mit den vorliegenden Nutzungsbedingungen zu verwenden.</li>
</ul>

<ul>
	<li>Du bist selbst dafür verantwortlich, die notwendigen Voraussetzungen für die Nutzung der PLATTFORM, wie etwa einen ausreichend schnellen Internetanschluss oder sonstige Hardware- oder Softwarevoraussetzungen, zu schaffen. Sofern der Zugang zur PLATTFORM über die APP erfolgt, ist diese nur für die Besitzer von iOS oder Android-Smartphones verfügbar. Die Einhaltung der allgemeinen Geschäftsbedingungen von Anbietern, deren Services für die Nutzung der APP benötigt werden (wie etwa Apple oder google), obliegt allein dir.</li>
</ul>

<ol start="3">
	<li>NUTZUNGSBESCHRÄNKUNGEN</li>
</ol>

<ul>
	<li>Die Nutzung der PLATTFORM steht nur Personen über 18 Jahren zur Verfügung.</li>
</ul>

<ul>
	<li>Du darfst die PLATTFORM nur für rechtmäßige und zulässige Zwecke nutzen. Du wirst durch die Nutzung der PLATTFORM insbesondere nicht:</li>
</ul>

<ol style="list-style-type:lower-alpha">
	<li>die Rechte von ROODIE, anderen Nutzern oder dritten Personen (wie insbesondere, aber nicht ausschließlich, Datenschutz- und Veröffentlichungsrechte, Rechte am geistigen Eigentum bzw. sonstige Eigentumsrechte) verletzen, widerrechtlich verwenden oder gegen sie verstoßen; sowie</li>
	<li>Informationen anderer Nutzer auf unzulässige oder unberechtigte Art und Weise erfassen oder sammeln.</li>
</ol>

<ul>
	<li>Du darfst, soweit gesetzlich nicht ausdrücklich zulässig, die PLATTFORM nicht verändern, verbreiten, kopieren, dekompilieren, neu anordnen, veröffentlichen, nachbauen, vervielfältigen oder abgeleitete Werke auf ihrer Grundlage anfertigen (oder andere unterstützen, dies zu tun). Insbesondere ist es dir verboten (i) den Code der PLATTFORM einem reverse-engineering zu unterziehen oder sonst zu modifizieren, (ii) Viren oder sonstige schädliche Software in die PLATTFORM einzuspielen, (iii) unberechtigten Zugriff auf die PLATTFORM zu erlangen oder diesen Dritten zu gewähren sowie (iv) Software oder APIs zu entwickeln und/oder bereitzustellen, die im Wesentlichen wie die PLATTFORM funktionieren.</li>
</ul>

<ul>
	<li>Es ist dir lediglich gestattet, die PLATTFORM für deine eigenen, privaten Zwecke (ausgeschlossen sind kommerzielle oder gewerbliche Zwecke) zu nutzen. Eine Weitergabe an Dritte ist ausgeschlossen.</li>
</ul>

<ul>
	<li>Bei einer Verletzung der Beschränkungen dieses Abschnitts&nbsp;3 sind wir jederzeit berechtigt, deinen Zugang zu dieser PLATTFORM auszusetzen. Darüberhinausgehende Schadenersatzansprüche von uns bleiben davon unberührt.</li>
</ul>

<ol start="4">
	<li>PREIS<br />
	Die Nutzung der PLATTFORM erfolgt kostenlos. Kosten, die im Zusammenhang mit der Nutzung der PLATTFORM – wie etwa Kosten für den Datentransfer oder die Schaffung der Voraussetzungen nach Abschnitt&nbsp;2.5 – anfallen, sind von dir zu tragen.</li>
</ol>

<ol start="5">
	<li>WIDERRUFSRECHT UND ENTFALL DES RÜCKTRITTSRECHTS GEMÄß&nbsp;§&nbsp;18 FAGG</li>
</ol>

<ul>
	<li>Du kannst deine Zustimmung zum Nutzungsverhältnis mit ROODIE jederzeit formlos (etwa per E-Mail oder Brief) innerhalb von 14 Tagen nach Vertragsabschluss ohne Angabe von Gründen widerrufen. Der Widerruf ist zu richten an</li>
</ul>

<p style="text-align:center">ROODIE HEALTH GMBH</p>

<p style="text-align:center">FN&nbsp;516782&nbsp;z</p>

<p style="text-align:center">Handelsgericht Wien</p>

<p style="text-align:center">Urstein Süd 15, 5412 Puch bei Hallein, Österreich</p>

<p style="text-align:center">E-Mail:&nbsp;<a href="mailto:hallo@roodie-health.">hallo@roodie-health.</a>com</p>

<ul>
	<li>Die Ausübung des Widerrufsrechts gemäß diesem Abschnitt&nbsp;5 kann mittels des Muster-Widerrufsformulars erfolgen, welches sich am Ende der Nutzungsbedingungen befindet.</li>
</ul>

<ul>
	<li>Im Falle eines wirksamen Widerrufs sind die beiderseits empfangenen Leistungen zurückzugewähren und etwaige wirtschaftliche Vorteile sind herauszugeben. Verpflichtungen zur Rückerstattung müssen innerhalb von 30 Tagen erfüllt werden. Die Frist beginnt für dich mit der Absendung der Widerrufserklärung, für uns mit deren Empfang.</li>
</ul>

<ul>
	<li>Verbraucher haben kein Rücktrittsrecht, wenn mit der Ausführung einer Dienstleistung auf Verlangen des Verbrauchers vor Ablauf der 14-tägigen Rücktrittsfrist des §&nbsp;11 FAGG begonnen wird; in einem solchen Fall entfällt das Rücktrittsrecht nach rechtlicher Belehrung über diese Folgen der vorzeitigen Ausführung.</li>
</ul>

<ul>
	<li><strong>Du nimmst hiermit zur Kenntnis und stimmt ausdrücklich zu, dass mit der erstmaligen Nutzung der PLATTFORM die Leistungsausführung von ROODIE vor Ablauf der Rücktrittsfrist des §&nbsp;11 FAGG erfolgt und damit der Verlust des Rücktrittsrechts gemäß&nbsp;§&nbsp;18 FAGG verbunden ist.</strong></li>
</ul>

<ol start="6">
	<li>SUPPORT UND UPDATES</li>
</ol>

<ul>
	<li>ROODIE bietet Support für die PLATTFORM unter roodie-health.com/hilfe an.</li>
	<li>ROODIE wird Updates und Fehlerkorrekturen nach eigenem Ermessen zur Verfügung stellen. ROODIE ist nicht verpflichtet, bestimmte Updates zu entwickeln oder Wartungsleistungen zu erbringen.</li>
</ul>

<ol start="7">
	<li>VERFÜGBARKEIT UND GEWÄHRLEISTUNG<br />
	Du hast das Recht, Gewährleistungsansprüche im Rahmen der gesetzlichen Gewährleistungsbestimmungen geltend zu machen. Wir leisten jedoch keine Gewähr</li>
</ol>

<ol style="list-style-type:lower-alpha">
	<li>für eine ständige Verfügbarkeit der PLATTFORM. Ausfallszeiten durch Wartungen, Software-Updates und aufgrund von Umständen (wie etwa technischer Probleme Dritter, höherer Gewalt), die nicht in unseren Einflussbereich liegen und daher von uns auch nicht zu vertreten sind und durch die die Services von ROODIE nicht erreichbar sind, können nicht ausgeschlossen werden;</li>
	<li>für Fehler, Störungen oder Schäden, die auf unsachgemäße Bedienung oder die Eingabe von Fehlinformationen durch den Nutzer zurückzuführen sind; sowie</li>
	<li>dafür, dass die Leistungen deinen Erwartungen entsprechen, insbesondere dass Erfolge aus der Nutzung der PLATTFORM sowie aus der Inanspruchnahme der PLATTFORM erzielt werden.</li>
</ol>

<ol start="8">
	<li>HAFTUNG</li>
</ol>

<ul>
	<li>Vorbehaltlich Abschnitt&nbsp;2, ist unsere Haftung aufgrund leichter Fahrlässigkeit generell ausgeschlossen. ROODIE haftet ausschließlich für Schäden, die auf vorsätzlichem oder grob fahrlässigem Verhalten von ROODIE basieren.<br />
	&nbsp;</li>
	<li>Die in Abschnitt&nbsp;1 festgelegten Haftungsbeschränkungen gelten nicht für Schäden aus Verletzung des Lebens, des Körpers oder der Gesundheit an Personen sowie für den Fall, dass anders lautende zwingende gesetzliche Regelungen entgegenstehen.<br />
	&nbsp;</li>
	<li>Die auf der PLATTFORM angebotenen Inhalte und Dienste sind ausschließlich zu Informationszwecken bestimmt und ersetzen selbstverständlich nicht die persönliche Beratung oder Behandlung durch einen Arzt oder andere professionelle Beratungen. Die PLATTFORM hilft dir lediglich dabei, den Arzt, bei dem du die persönliche Beratung oder Behandlung bekommen willst, zu finden. Bei Notfällen, akuten Gesundheitsproblemen oder dringenden Fragen wird dir dringendst empfohlen, dich unbedingt an einen Arzt oder die medizinischen Notrufnummern zu wenden.<br />
	&nbsp;</li>
	<li>Klarstellend wird darauf hingewiesen, dass die Verträge mit den medizinischen Partnerunternehmen sowie die Behandlungsverträge mit den jeweiligen Ärzten des medizinischen Partnerunternehmens zwischen dir und diesen dritten Parteien zustande kommen und ROODIE keinerlei Pflichten aus solch einem Vertragsverhältnis treffen und wir für Verletzungen aus diesen Vertragsverhältnissen nicht haftbar gemacht werden können. Wir übernehmen keinerlei Haftung für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der von Dritten bereitgestellten Informationen.</li>
</ul>

<ul>
	<li>Du nimmst zustimmend zur Kenntnis, dass diese Nutzungsbedingungen nur für die Nutzung der PLATTFORM gelten und wir keinerlei Einfluss darüber haben, welche Bedingungen die medizinischen Partnerunternehmen oder die behandelnden Ärzte dir in Verbindung mit der Nutzung ihrer Websites, der Weitervermittlung an die Ärzte oder der Behandlung auferlegen. Es obliegt dir in deiner alleinigen Verantwortlichkeit die damit verbundenen Bestimmungen einzuhalten.</li>
</ul>

<ol start="9">
	<li>IMMATERIALGÜTERRECHTE<br />
	Mit Ausnahme der dir in Abschnitt&nbsp;2.4 eingeräumten Lizenz behalten wir uns alle Rechte an der PLATTFORM einschließlich aller weltweiten Technologie-, Immaterialgüter- und Eigentumsrechte daran ausdrücklich vor. Dir ist es nicht gestattet, Urheberrechtsvermerke oder sonstige Eigentumsvermerke von ROODIE von der PLATTFORM zu entfernen, zu verbergen oder unkenntlich zu machen.</li>
</ol>

<ol start="10">
	<li>SICHERHEIT</li>
</ol>

<ul>
	<li>Wir stellen die Absicherung sämtlicher Daten und Verbindungen durch stetiges Monitoring des Betriebes, sorgfältige Auswahl der Systemkomponenten und sicherheitsgeprüfte Software sicher. Die PLATTFORM und die APP unterliegen einem stetigen Audit- und Aktualisierungszyklus, um potentiellen Sicherheitslücken vorzubeugen.</li>
	<li>Unsere internen Netzwerke sind durch einen mehrstufigen, aktiven Schutz vor komplexem schädlichem Code und vor Angriffen von außen geschützt. Der externe Zugriff auf die IT-Systeme und Datenbanken wird von uns mittels SSH-Schlüssel-Identifikation über eine verschlüsselte Datenverbindung von einer beliebigen IP-Adresse aus betrieben. Unsere IT-Tools und Software entsprechen stets dem Marktstandard.</li>
	<li>PLATTFORM, APP und das entsprechende Backend kommunizieren mittels Ende-zu-Ende-Verschlüsselung. Im Falle eines hypothetischen Angriffs auf deine Userdaten sind weder du noch deine Daten identifizierbar. Sämtliche Gesundheitsdaten sind von den Nutzerdaten getrennt gespeichert und sicherheitstechnisch geschützt. Startest du eine Session in der PLATTFORM werden die erforderlichen Gesundheitsdaten vom Client entschlüsselt.</li>
</ul>

<ol start="11">
	<li>LINKS<br />
	Die PLATTFORM kann Links zu Websites Dritter enthalten. Diese unterliegen nicht der Kontrolle und Verantwortung von ROODIE. Zudem übernehmen wir keine Haftung für verlinkte Inhalte und externe Angebote.</li>
</ol>

<ol start="12">
	<li>DATENSCHUTZ</li>
</ol>

<ul>
	<li>Wir sind verpflichtet, die Bestimmungen des Datenschutzgesetzes (DSG), der Datenschutz-Grundverordnung (DSGVO) sowie allfällige weitere gesetzliche Geheimhaltungsverpflichtungen einzuhalten.</li>
	<li>Ferner verarbeitet ROODIE zum Zweck der Vertragserfüllung die dafür erforderlichen personenbezogenen Daten. Die detaillierten datenschutzrechtlichen Informationen (Datenschutzmitteilung) gemäß Art 13&nbsp;ff DSGVO sind unter <a href="https://roodie-health.com/">https://roodie-health.com/</a> verfügbar.</li>
</ul>

<ol start="13">
	<li>ÄNDERUNG DER NUTZUNGSBEDINGUNGEN<br />
	Wir behalten uns das Recht vor, diese Nutzungsbedingungen von Zeit zu Zeit anzupassen, um insbesondere aber nicht ausschließlich, die gesetzlichen Bestimmungen oder Anforderungen einzuhalten, der Wirtschaftlichkeit zu entsprechen oder den Benutzerinteressen entgegenzukommen. Die Nutzungsbedingungen sind in der jeweiligen gültigen Fassung auf roodie-health.com einsehbar.</li>
</ol>

<ol start="14">
	<li>ONLINE-STREITBEILEGUNG<br />
	Zur Beilegung von Streitigkeiten aus Online-Kaufverträgen und Online-Dienstleistungsverträgen ist bei der Europäischen Kommission eine Online-Streitbeilegungs(OS)-Plattform eingerichtet. Verbrauchern gibt dies die Möglichkeit, Streitigkeiten zunächst außergerichtlich zu klären. Diese ist unter dem Link: <a href="https://webgate.ec.europa.eu/odr/">https://webgate.ec.europa.eu/odr/</a> aufrufbar. ROODIE nimmt nicht an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil.</li>
</ol>

<ol start="15">
	<li>SCHLUSSBESTIMMUNGEN</li>
</ol>

<ul>
	<li>Wenn eine Bestimmung dieser Nutzungsbedingungen unwirksam ist oder wird oder dieser Vertrag eine Lücke enthält, berührt dies nicht die Gültigkeit der übrigen Bestimmungen.</li>
</ul>

<ul>
	<li>Diese Nutzungsbedingungen und die gesamten Rechtsbeziehungen und Streitigkeiten zwischen dir und ROODIE unterliegen ausschließlich österreichischem Recht mit Ausnahme der Verweisungsnormen und des UN-Kaufrechts. Dieser Abschnitt&nbsp;2 ist nicht relevant für Nutzer, die Konsumenten im Sinne des jeweils anwendbaren Rechts ist.</li>
</ul>

<ul>
	<li>Erfüllungsort und ausschließlicher Gerichtsstand für sämtliche Streitigkeiten ist Wien, Österreich. Dieser Abschnitt&nbsp;3 ist nicht relevant für Nutzer, die Konsumenten im Sinne des jeweils anwendbaren Rechts ist.</li>
</ul>

<ul>
	<li>Sofern diese Nutzungsbedingungen in mehrere Sprachen übersetzt werden sollten, ist die deutsche Version die maßgebende Version.</li>
</ul>

<p></p>

<p><strong><em>Muster-Widerrufsformular</em></strong></p>

<p></p>

<p>Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück an</p>

<p style="text-align:center">ROODIE HEALTH GMBH</p>

<p style="text-align:center">FN 516782 z</p>

<p style="text-align:center">Handelsgericht Wien</p>

<p style="text-align:center">Urstein Süd 15, 5412 Puch bei Hallein, Österreich</p>

<p style="text-align:center">E-Mail: hallo@roodie-health.com</p>

<p>Hiermit widerrufe ich den von mir abgeschlossenen Vertrag über die Nutzung der Online-Dienstleistungen die unter <strong>roodie.de</strong> angeboten werden.</p>

<p>Bestellt am/ erhalten am:</p>

<p>Name des Verbrauchers:</p>

<p>Datum:</p>

<p>Unterschrift des Verbrauchers (nur bei Mitteilung auf Papier)</p>
`;

export {
  appOrigin,
  setAppOrigin,
  setAxiosBaseUrl,
  getDataString,
  ztkLocations,
  generalPrivacyPolicy,
  generalUsagePolicy,
};
